import React, { useContext } from "react";
import HeaderBar from "../components/HeaderBar";
import getCurrentSkin from "../utils/getCurrentSkin";
import { ThemeContext } from "../context/ThemeContext";
import AdminLayoutWrapper from "../components/AdminLayoutWrapper";
import { useNavigate } from "react-router-dom";

import {
  FaBuilding,
  FaCodeBranch,
  FaSitemap,
  FaUserFriends,
  FaUserTag,
  FaDatabase,
  FaCogs,
} from "react-icons/fa";

const AdminHome = () => {
  const { isDark, skin, setSkin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor, baseShade } = currentSkin;

  const buttonClass = `bg-${baseColor}-${baseShade}`;
  const hoverClass = `hover:bg-${baseColor}-700`;

  const navigate = useNavigate();

  const cards = [
    {
      title: "Company Master",
      desc: "Manage company profile & settings",
      icon: <FaBuilding />,
      path: "/adminMaster/companyMaster",
    },
    {
      title: "Branch Listing",
      desc: "Create / edit branch setup",
      icon: <FaCodeBranch />,
      path: "/adminMaster/branch-listing",
    },
    {
      title: "Department Master",
      desc: "Maintain department hierarchy",
      icon: <FaSitemap />,
      path: "/adminMaster/DepartmentMasterListing",
    },
    {
      title: "User Management",
      desc: "Admins, roles & access control",
      icon: <FaUserFriends />,
      path: "/adminMaster/UserSetupMasterListing",
    },
    {
      title: "User Type Master",
      desc: "Configure user type definitions",
      icon: <FaUserTag />,
      path: "/adminMaster/UesrTypeMasterListing",
    },
    {
      title: "FinYear DataBase Change",
      desc: "Switch DB based on financial year",
      icon: <FaDatabase />,
      path: "/adminMaster/FinYearDataBaseChange",
    },
    {
      title: "Payroll Customization",
      desc: "Manage payroll rules & settings",
      icon: <FaCogs />,
      path: "/adminMaster/PayrollCustomizationNew",
    },
  ];

  return (
    <AdminLayoutWrapper>
      <div className={`min-h-screen ${isDark ? "bg-gray-900" : "bg-gray-100"}`}>
        <HeaderBar
          title={<span className="font-dmserif text-3xl">ADMIN HOME</span>}
          setSkin={setSkin}
          currentSkin={skin}
        />

        <div
          className={`p-6 mt-6 rounded-2xl shadow-xl border ${
            isDark
              ? "bg-gradient-to-br from-white/20 to-white/5 backdrop-blur-md border-white/10 text-white"
              : "bg-white text-black"
          }`}
        >
          {/* Top section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div>
              <h1 className={`text-2xl font-bold ${isDark ? "text-white" : "text-gray-900"}`}>
                Welcome to Admin Panel
              </h1>
              <p className={`${isDark ? "text-white/60" : "text-gray-600"} mt-1`}>
                Choose a module to manage system configuration.
              </p>
            </div>

            <button
              onClick={() => navigate("/home")}
              className={`px-5 py-2 rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 ${buttonClass} ${hoverClass} text-white`}
            >
              Go to Home
            </button>
          </div>

          {/* Cards */}
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {cards.map((c, idx) => (
              <button
                key={idx}
                onClick={() => navigate(c.path)}
                className={`text-left rounded-2xl border p-5 shadow-md hover:shadow-xl transition-all duration-200 transform hover:-translate-y-1 ${
                  isDark
                    ? "bg-white/5 border-white/10 hover:bg-white/10"
                    : "bg-gray-50 border-gray-200 hover:bg-white"
                }`}
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`w-12 h-12 rounded-xl flex items-center justify-center text-white shadow-lg ${buttonClass}`}
                  >
                    <span className="text-lg">{c.icon}</span>
                  </div>

                  <div>
                    <h2 className={`font-semibold text-lg ${isDark ? "text-white" : "text-gray-900"}`}>
                      {c.title}
                    </h2>
                    <p className={`text-sm mt-1 ${isDark ? "text-white/60" : "text-gray-600"}`}>
                      {c.desc}
                    </p>
                  </div>
                </div>
              </button>
            ))}
          </div>

          {/* Quick Note */}
        </div>
      </div>
    </AdminLayoutWrapper>
  );
};

export default AdminHome;
